export class StorageGame {
    constructor() {
        this._data = window.localStorage;
    }
    save(key, data) {
        try {
            this._data.setItem(`crazy-${key}`, data);
        }
        catch (error) {
            console.error(error);
            return false;
        }
        return true;
    }
    get(key) {
        try {
            return this._data.getItem(`crazy-${key}`);
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    del(key) {
        try {
            this._data.removeItem(`crazy-${key}`);
        }
        catch (error) {
            console.error(error);
            return false;
        }
        return true;
    }
}
